import { PageType } from '@/types/models'
import { isFacetPageType, isLocationPageType } from '../useCases/pageTypeCheck'
import { getLocationQuickLinks } from '@/domain/location'
import { getTermQuickLinks } from '@/domain/term'
import { QuickLink } from '@prisma/client'
import { Location } from '@/types/models/Location.model'

export type QuickLinksData = {
  location?: Location
  term: {
    quick_links: QuickLink[]
  }
}

export function getRelatedLinks(
  pageType: PageType,
  data: QuickLinksData
): QuickLink[] {
  if (isLocationPageType(pageType)) {
    return [
      ...getLocationQuickLinks(data.location),
      ...getTermQuickLinks(data.term)
    ]
  } else if (isFacetPageType(pageType) && data.term) {
    return getTermQuickLinks(data.term)
  } else {
    return []
  }
}
